import type { ReactNode } from "react";

export function LinkCard({
  icon,
  label,
  badge,
  onClick,
}: {
  icon: ReactNode;
  label: string;
  /** 右端に表示する小さなバッジ文字列 (例: "済") */
  badge?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex cursor-pointer items-center gap-2.5 rounded-lg border border-[var(--rule-soft)] bg-[var(--bg-raised)] px-3.5 py-3 text-left text-[length:var(--fs-sm)] font-medium text-[var(--ink)]"
    >
      <span className="flex items-center text-[var(--ink-2)]">{icon}</span>
      <span className="flex-1">{label}</span>
      {badge && (
        <span className="rounded-full bg-[var(--st-done-bg)] px-2 py-0.5 text-[length:var(--fs-xs)] font-semibold text-[var(--st-done-ink)]">
          {badge}
        </span>
      )}
      <span className="text-[var(--ink-4)]">›</span>
    </button>
  );
}
